export default function(context) {
  if (context.app.$auth.user.type !== 'superadmin') {
    return context.redirect('/forbidden')
  }
}
